package com.bikompanion.ui.composables

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.bikompanion.ui.models.ParkingCountdownStatus
import com.bikompanion.ui.preview.PreviewSurface
import com.bikompanion.ui.strings.LocalStrings

/**
 * Tells the rider how much longer Bicing's post-parking lock has left on the bike they just
 * voted on, so they know when it — or the dock it's in — is worth trying again instead of
 * walking off to find another station for nothing.
 */
@Composable
internal fun ParkingCountdownIndicator(
    status: ParkingCountdownStatus,
    modifier: Modifier = Modifier,
) {
    if (status !is ParkingCountdownStatus.Counting) return
    Surface(
        modifier = modifier,
        shape = MaterialTheme.shapes.medium,
        color = MaterialTheme.colorScheme.surface.copy(alpha = 0.92f),
        contentColor = MaterialTheme.colorScheme.onSurface,
        shadowElevation = 2.dp,
    ) {
        Text(
            text = LocalStrings.current.bicingNextPickup(status.secondsRemaining.toMinutesAndSeconds()),
            style = MaterialTheme.typography.labelMedium,
            modifier = Modifier.padding(horizontal = 12.dp, vertical = 8.dp),
        )
    }
}

/** "9:05" rather than a raw second count, since ten minutes of seconds is hard to read at a glance. */
private fun Int.toMinutesAndSeconds(): String {
    val minutes = this / 60
    val seconds = this % 60
    return "$minutes:${seconds.toString().padStart(2, '0')}"
}

@Preview
@Composable
private fun ParkingCountdownIndicatorPreview() {
    PreviewSurface {
        Column(
            modifier = Modifier.padding(16.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            ParkingCountdownIndicator(status = ParkingCountdownStatus.Counting(secondsRemaining = 545))
            // The seconds padded, which is the case the formatting exists for.
            ParkingCountdownIndicator(status = ParkingCountdownStatus.Counting(secondsRemaining = 7))
        }
    }
}
